import React from "react";
import "./HeroSection.scss";
import web_dev_img from "../../images/img1.svg";
const HeroSection = () => {
  return (
    <div className="hero-section mt-5 mb-5 container">
      <div className="row">
        <div className="col-md-6 align-self-center hero-txt">
          <h1>
            Hi,
            <br />
            I'm <font className="text-primary">Sahil Tagra</font>,
            <br />
            Full Stack Web Developer.
          </h1>
          <h6 className="text-primary pro-lan">
            REACT JS / MERN STACK / JavaScript
          </h6>
          <button className="btn btn-outline-success ml-2 contact-btn">
            Contact Me
          </button>
        </div>
        <div className="col-md-5 ml-auto hero-img m-5">
          <img src={web_dev_img}></img>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
